/** Filtertilstand for planlista på landingssiden. */
export interface PlanFilters {
    statuses: string[];
    plantyper: string[];
    lovreferanser: string[];
    kommuner: string[];
    dateFrom: Date | null;
    dateTo: Date | null;
}

export const emptyFilters: PlanFilters = {
    statuses: [],
    plantyper: [],
    lovreferanser: [],
    kommuner: [],
    dateFrom: null,
    dateTo: null,
};

export type SortField = 'plannavn' | 'planId' | 'vedtaksdato' | 'ikrafttredelsesdato';
export type SortDirection = 'asc' | 'desc';

export interface SortOption {
    field: SortField;
    direction: SortDirection;
    /** i18n-nøkkel for visningstekst. */
    labelKey: string;
}

export const sortOptions: SortOption[] = [
    { field: 'plannavn', direction: 'asc', labelKey: 'landing.sort.navnAsc' },
    { field: 'plannavn', direction: 'desc', labelKey: 'landing.sort.navnDesc' },
    { field: 'planId', direction: 'asc', labelKey: 'landing.sort.planIdAsc' },
    { field: 'planId', direction: 'desc', labelKey: 'landing.sort.planIdDesc' },
    { field: 'vedtaksdato', direction: 'desc', labelKey: 'landing.sort.vedtaksdatoDesc' },
    { field: 'ikrafttredelsesdato', direction: 'desc', labelKey: 'landing.sort.ikraftDesc' },
];
